export const vars = {
    body: document.querySelector('body'),
    header: document.querySelector('.header'),
    mobileMenu: document.querySelector('.mobile-menu'),
}